import { render, staticRenderFns } from "./ColorOwlCarousel.vue?vue&type=template&id=1cd1a8b6"
import script from "./ColorOwlCarousel.vue?vue&type=script&lang=js"
export * from "./ColorOwlCarousel.vue?vue&type=script&lang=js"
import style0 from "./ColorOwlCarousel.vue?vue&type=style&index=0&id=1cd1a8b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports